export class ShopOfferPosition {
    quantity: number;
    productName: string;
    priceTotal: number;

    constructor({quantity, productName, priceTotal}: ShopOfferPositionDTO) {
        this.quantity = quantity;
        this.productName = productName;
        this.priceTotal = priceTotal;
    }
}

export default class ShopOffer {
    offerId: string;
    createdAt: string;
    isOrdered: boolean;
    persId: string;
    positions: ShopOfferPosition[];


    constructor({
                    offerId,
                    createdAt,
                    isOrdered,
                    persId,
                    positions,
                }: ShopOfferDTO) {
        this.offerId = offerId;
        this.createdAt = createdAt;
        this.isOrdered = isOrdered;
        this.persId = persId;
        this.positions = positions.map(p => new ShopOfferPosition(p));
    }
}

export interface ShopOfferDTO {
    offerId: string;
    createdAt: string;
    isOrdered: boolean;
    persId: string;
    positions: ShopOfferPositionDTO[];
}

export interface ShopOfferPositionDTO {
    quantity: number;
    productName: string;
    priceTotal: number;
}